import React, { useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { POPPINS } from "./adminConstants";

const today = () => new Date().toISOString().slice(0, 10);
const daysAgo = (n) => new Date(Date.now() - n * 24 * 60 * 60 * 1000).toISOString().slice(0, 10);

const ExportDateRangeDialog = ({ open, title, loading, onClose, onExport }) => {
  const [startDate, setStartDate] = useState(daysAgo(30));
  const [endDate, setEndDate]     = useState(today());

  const handleExport = () => onExport(startDate, endDate);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ ...POPPINS, fontWeight: 700, fontSize: "1rem", pb: 0.5 }}>
        {title}
      </DialogTitle>

      <DialogContent>
        <Typography variant="body2" sx={{ ...POPPINS, color: "#666", mb: 2.5, mt: 0.5 }}>
          Select a date range to filter the export. All users are included.
        </Typography>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <TextField
            label="Start Date"
            type="date"
            size="small"
            fullWidth
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            inputProps={{ max: endDate }}
            sx={POPPINS}
          />
          <TextField
            label="End Date"
            type="date"
            size="small"
            fullWidth
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            inputProps={{ min: startDate, max: today() }}
            sx={POPPINS}
          />
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <Button
          onClick={onClose}
          size="small"
          disabled={loading}
          sx={{ ...POPPINS, textTransform: "none", color: "#555" }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          size="small"
          onClick={handleExport}
          disabled={loading || !startDate || !endDate}
          startIcon={loading ? <CircularProgress size={13} sx={{ color: "#fff" }} /> : <FileDownloadIcon />}
          sx={{ ...POPPINS, textTransform: "none" }}
        >
          {loading ? "Exporting…" : "Export CSV"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExportDateRangeDialog;
